import { AbstractControl, ValidationErrors } from "@angular/forms";

/**
 * Regular expression for Base64-encoded strings. Matches any number of groups of 4 valid Base64 characters,
 * followed by an optional final group of 4 with either 1 or 2 padding characters (equals signs) at the end.
 */
const base64Regex: RegExp = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;

/**
 * A validator function that validates the control's value is a valid Base64-encoded string.
 */
export function isValidBase64(control: AbstractControl): ValidationErrors | null {
    //Note that an empty string is valid Base64, so we are testing for null/undefined instead of testing the truthiness of the value.
    if (control.value == null || !base64Regex.test(control.value)) {
        return {
            base64: true
        };
    }

    return null;
}